import React from 'react';
import Heading from 'components/common/Heading/Heading';
import helper from 'components/utils/helper';
import { Container, Link, Icon, ItemList, Item, ImageContainer, Picture, InfoContainer, Info, Date, Title, Author } from './RelatedStories.style';

const RelatedStories = ({stories, currentTag}) => {
    
    return ( 
        <Container>
            <Heading level="h6" fontWeight="inherit">
                <Link href={`/story${currentTag ? `?tag=${encodeURIComponent(currentTag.replace(' ', '-').toLowerCase())}`: ''}`}>
                    Related stories <Icon className="fas fa-chevron-right"/>
                </Link>
            </Heading>
            <ItemList>
                {stories.map((story, i) =>
                    <Item href={story.url} key={i}>
                        <ImageContainer>
                            <Picture>{helper.renderImage(story.gallery[0], 'small')}</Picture>
                        </ImageContainer>
                        <InfoContainer>
                            <Info>
                                <Date>{story.publishedDate ? new window.Date(story.publishedDate).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : ''}</Date>
                                <Title>{story.title}</Title>
                                <Author>{story.author.name}</Author>
                            </Info>
                        </InfoContainer>
                    </Item>
                )}
            </ItemList>
        </Container>
     );
}
 
export default RelatedStories;